import React from 'react';
import { ShieldCheck, CheckCircle2, Star } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-dark-DEFAULT" data-id="element-50">
      <div className="max-w-4xl mx-auto px-4" data-id="element-51">
        <div className="border-2 border-trust/40 bg-gradient-to-br from-trust/10 to-dark-50 p-8 md:p-12 rounded-2xl flex flex-col md:flex-row items-center gap-8" data-id="element-52">
          <div className="flex-shrink-0 relative" data-id="element-53">
            <div className="absolute inset-0 bg-trust/20 blur-2xl rounded-full" data-id="element-54"></div>
            <ShieldCheck className="relative w-28 h-28 text-trust stroke-1" data-id="element-55" />
          </div>
          <div className="text-center md:text-left" data-id="element-56">
            <h2 className="text-3xl font-heading font-bold text-white mb-4" data-id="element-57">
              Our Quality Satisfaction Promise
            </h2>
            <p className="text-gray-300 mb-4" data-id="element-58">
              We stand behind every word in this guide. The Section 609
              strategies, templates, and step-by-step instructions are
              battle-tested and based on federal law.
            </p>
            <p className="text-gray-300 mb-6" data-id="element-59">
              If you feel the content doesn't deliver exactly what we promised —{' '}
              <span className="text-white font-bold" data-id="element-60">
                reach out to us and we'll make it right.
              </span>{' '}
              We're committed to your success.
            </p>
            <div className="flex flex-wrap gap-3 justify-center md:justify-start" data-id="element-61">
              {['Proven Strategies', 'Federal Law Based', "We've Got Your Back"].map(badge => <div key={badge} className="flex items-center gap-2 bg-success/10 border border-success/30 px-3 py-1 rounded-full" data-id="element-62">
                  <CheckCircle2 className="w-4 h-4 text-success" data-id="element-63" />
                  <span className="text-success text-sm font-bold" data-id="element-64">
                    {badge}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}